import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const API_URL = 'http://localhost:5000/api';

const VerifyWhatsApp = () => {
  const [otp, setOtp] = useState('');
  const [phone_number, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const statePhone = location.state?.phone_number;
    if (statePhone) {
      setPhoneNumber(statePhone);
    }
  }, [location]);

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/auth/verify-whatsapp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone_number, otp }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Verifikasi gagal');
        return;
      }

      setSuccess(data.message + ' Silakan login.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    // TODO: Implement resend OTP functionality
    setResendTimer(60);
    setSuccess('OTP telah dikirim ulang ke WhatsApp Anda');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center mb-2 text-blue-600">Yayasan BCN</h1>
        <h2 className="text-2xl font-bold mb-6 text-center">Verifikasi WhatsApp</h2>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            {success}
          </div>
        )}

        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded">
          <p className="text-sm text-blue-800">
            <strong>Nomor WhatsApp:</strong> {phone_number}
          </p>
          <p className="text-xs text-blue-600 mt-2">
            Kode OTP telah dikirim ke nomor WhatsApp Anda
          </p>
        </div>

        <form onSubmit={handleVerify} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Masukkan Kode OTP</label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              className="w-full px-4 py-2 text-center text-2xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 tracking-widest"
              placeholder="000000"
              maxLength="6"
              required
            />
            <p className="text-xs text-gray-500 mt-2">
              Masukkan 6 digit kode yang diterima di WhatsApp
            </p>
          </div>

          <button
            type="submit"
            disabled={loading || otp.length !== 6}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 font-semibold"
          >
            {loading ? 'Sedang memverifikasi...' : 'Verifikasi'}
          </button>
        </form>

        <div className="text-center mt-6">
          <p className="text-sm text-gray-600 mb-2">Belum menerima kode?</p>
          <button
            onClick={handleResendOTP}
            disabled={resendTimer > 0}
            className="text-blue-600 hover:underline text-sm font-semibold disabled:text-gray-400"
          >
            {resendTimer > 0 ? `Kirim ulang dalam ${resendTimer}s` : 'Kirim ulang OTP'}
          </button>
        </div>

        <p className="text-center mt-6 text-sm text-gray-600">
          Ubah nomor WhatsApp?{' '}
          <button
            onClick={() => navigate('/register')}
            className="text-blue-600 hover:underline font-semibold"
          >
            Daftar ulang
          </button>
        </p>
      </div>
    </div>
  );
};

export default VerifyWhatsApp;
